import React from 'react';
import styled, { css } from 'styled-components';
import { useRouter } from 'next/router';

import { ContentContainerSmall } from '@/components/ContentContainer';
import FacebookIcon from '@/assets/svg/socials-footer/facebook.svg';
import VkIcon from '@/assets/svg/socials-footer/vk.svg';
import OkIcon from '@/assets/svg/socials-footer/odnoklassniki.svg';
import TwitterIcon from '@/assets/svg/socials-footer/twitter.svg';
import TelegramIcon from '@/assets/svg/socials-footer/telegram.svg';
import { media } from '@/utils/mixin';
import share, { SocialType } from '@/utils/share';

function Socials() {
  const router = useRouter();

  function handleSocialShare(type: SocialType) {
    return () => {
      share(type, router.asPath);
    };
  }

  return (
    <Component>
      <ContentContainerSmall>
        <Content>
          <Title>Поделись с друзьями</Title>
          <SocialsList>
            <SocialLink onClick={handleSocialShare('facebook')}>
              <FacebookIcon />
            </SocialLink>
            <SocialLink onClick={handleSocialShare('vk')}>
              <VkIcon />
            </SocialLink>
            <SocialLink onClick={handleSocialShare('odnoklassniki')}>
              <OkIcon />
            </SocialLink>
            <SocialLink onClick={handleSocialShare('twitter')}>
              <TwitterIcon />
            </SocialLink>
            <SocialLink onClick={handleSocialShare('tg')}>
              <TelegramIcon />
            </SocialLink>
          </SocialsList>
        </Content>
      </ContentContainerSmall>
    </Component>
  );
}

export default Socials;

const Component = styled.section`
  z-index: 2;
  padding: 30px 0;

  ${media.tablet(
    css`
      padding: 20px 0;
    `
  )}

  ${ContentContainerSmall} {
    ${media.tablet(css`
      padding: 0 20px;
    `)}
  }
`;

const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 30px 60px;
  background: ${(props) => props.theme.white_1};
  box-shadow: ${(props) => props.theme.blackShadow100};

  ${media.tablet(css`
    padding: 30px 20px;
  `)}

  ${media.mobile(css`
    align-items: flex-start;
    flex-direction: column;
    background: none;
    box-shadow: none;
    padding: 0;
  `)}
`;

const Title = styled.span`
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  color: ${(props) => props.theme.black};

  ${media.tablet(css`
    font-size: 20px;
    line-height: 30px;
  `)}

  ${media.mobile(css`
    font-size: 24px;
    line-height: 32px;
  `)}
`;

const SocialsList = styled.div`
  display: flex;

  ${media.mobile(css`
    margin-top: 20px;
  `)}
`;

const SocialLink = styled.button`
  cursor: pointer;
  width: 40px;
  height: 40px;
  margin-left: 60px;

  ${media.mobile(css`
    margin-left: 0;

    &:not(:first-child) {
      margin-left: 20px;
    }
  `)}

  svg {
    width: 40px;
    height: 40px;

    path {
      fill: ${(props) => props.theme.black};
    }
  }

  &:hover {
    opacity: 0.6;
  }
`;
